<h2 mat-dialog-title>Удаление результата</h2>
<div mat-dialog-content>
  <p>Вы действительно хотите удалить результат?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Отмена</button>
  <button mat-button color="warn"
          cdkFocusInitial
          (click)="onSubmit()">Удалить
  </button>
</div>
